module.exports = __webpack_public_path__ + "static/logo-amaury-beaufort-d452605ea14c8ae64bd363d24914adc0.svg";